import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6253f648&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6253f648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6253f648",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/practice/code/index.vue
// module id = null
// module chunks = 